<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :show-close="options.showClose"
      :close-on-click-modal="options.modalClose"
      :close-on-press-escape="options.pressClose"
      :width="options.width"
      append-to-body
      top="0"
      custom-class="my-dialog"
    >
      <div slot="title" class="dialog-title">
        <div class="centerHead">
          <img
            v-if="options.icon"
            :src="$utils ? $utils.getPng(options.icon) : ''"
            class="img-tip"
            alt=""
          />
          <span>{{ options.title }}</span>
        </div>
        <fm-button
          v-if="options.isClose"
          @click="close"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div>
        <slot>{{ options.content }}</slot>
      </div>
      <div class="text-center" slot="footer">
        <slot name="dialog-footer">
          <div class="app-but primaryBtn" @click="handleClick">
            {{ options.btn }}
          </div>
        </slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'myDialog',
  data() {
    return {
      visible: false,
      options: {
        title: '安全提示',
        content: '',
        btn: '',
        width: '480px',
        isClose: true,
        modalClose: false,
        pressClose: false,
        showClose: false,
        icon: 'icon11',
      },
      callback: null,
    }
  },
  // 组件卸载时清理
  beforeDestroy() {
    this.visible = false
  },
  methods: {
    show(opt = {}, callback = () => {}) {
      this.visible = true
      this.callback = callback
      this.options = Object.assign({}, this.options, opt)
    },
    close() {
      this.visible = false
      this.callback('close')
      this.callback = null
    },
    handleClick() {
      this.visible = false
      this.callback('confirm')
      this.callback = null
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog .el-dialog__header {
  display: block !important;
  .el-dialog__close {
    display: none !important;
  }
  .centerHead {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.img-tip {
  width: 20px;
}
.dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .img-tip {
    margin-right: 8px;
  }
}
</style>
